import { useParams } from 'react-router-dom';
import { CheckCircle2, Droplet, PackageCheck, Store, Truck } from 'lucide-react';
import { CTASection } from '../../shared/components/CTASection';
import { FAQ } from '../../shared/components/FAQ';
import { ProductCard } from '../../shared/components/ProductCard';
import { SectionHeading } from '../../shared/components/SectionHeading';
import { ValueCard } from '../../shared/components/ValueCard';
import { oilFaqs } from '../../shared/data/faqs';
import { getProductBySlug, oilProducts } from '../../shared/data/products';
import { PageShell } from '../PageShell/index';
import { NotFound } from '../NotFound/index';

const comingSoonName = (name: string) => `${name} (Coming Soon)`;

export function OilDetail() {
  const { slug } = useParams();
  const product = slug ? getProductBySlug(slug) : undefined;
  if (!product || product.division !== 'Edible Oils') return <NotFound />;
  return (
    <PageShell title={comingSoonName(product.category)} eyebrow="Coming soon" path={`/edible-oils/${product.slug}`} description={product.seoDescription}>
      <section className="mx-auto w-full max-w-[1540px] px-4 py-14 sm:px-6 sm:py-20 lg:px-10">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="overflow-hidden rounded-[1.25rem] bg-gradient-to-br from-soil to-wheat text-ink shadow-soft">
            <img src={product.image} alt={`${product.name} visual`} loading="eager" className="h-80 w-full object-cover" />
            <div className="p-8">
              <Droplet className="h-12 w-12" />
              <h2 className="mt-6 text-4xl font-black">{comingSoonName(product.category)}</h2>
              <p className="mt-5 leading-8 text-ink/75">{product.shortDescription}</p>
            </div>
          </div>
          <div className="grid gap-4">{product.keyBenefits.map((benefit) => <div key={benefit} className="flex gap-3 rounded-2xl bg-white p-5 shadow-sm"><CheckCircle2 className="h-6 w-6 shrink-0 text-forest" /><p className="font-semibold text-charcoal/75">{benefit}</p></div>)}<div className="rounded-2xl bg-cream p-5"><p className="font-black text-ink">Pack sizes</p><p className="mt-2 text-charcoal/70">{product.packSizes.join(', ')}</p></div><div className="rounded-2xl bg-tint p-5"><p className="font-black text-forest">Disclaimer</p><p className="mt-2 text-charcoal/70">{product.disclaimer}</p></div></div>
        </div>
      </section>
      <CTASection title={`Request ${comingSoonName(product.category)} details`} description="Share buyer type, pack requirement, delivery location, and documentation needs." primaryLabel="Send Enquiry" primaryHref="/contact" />
    </PageShell>
  );
}
